import { render, staticRenderFns } from "./ForgotPass.vue?vue&type=template&id=65e97a29&scoped=true"
import script from "./ForgotPass.vue?vue&type=script&lang=js"
export * from "./ForgotPass.vue?vue&type=script&lang=js"
import style0 from "./ForgotPass.vue?vue&type=style&index=0&id=65e97a29&prod&lang=postcss"
import style1 from "./ForgotPass.vue?vue&type=style&index=1&id=65e97a29&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e97a29",
  null
  
)

export default component.exports